module.exports = "../dist/frontend/icons/ui/pin.svg?5a6cfa50d5c404130025b2d36f1d10e6";